/* eslint-disable no-undef */
import { WeatherDetailsWidget } from './weatherDetailsWidget';

const props = [];

export const WeatherDetailsWidgetDirective = reactDirective => reactDirective(WeatherDetailsWidget, props);
WeatherDetailsWidgetDirective.$inject = ['reactDirective'];

angular.module('WB.App').directive('weatherDetailsWidget', WeatherDetailsWidgetDirective);
